import React from "react";

import { useSelector } from "react-redux";
import Card from "react-bootstrap/Card";

import styles from "../../App.module.css";

const Home = () => {
  const isAuth = useSelector((state) => state.user.isLoggedIn);
  return (
    <Card className={styles["Card"]}>
      <Card body className={styles["CardLvl2"]}>
        <Card.Title className={styles["page-header"]}>
          RAPID Scholar Award Full Proposal Application
        </Card.Title>
        {/*
        <Card.Body className={styles["flex-wrapper-vert"]}>
          <div align="center">
            <h3>Submissions are closed.</h3>
          </div>
        </Card.Body>
        */}
        
        <Card.Body className={styles["flex-wrapper-vert"]}>
          <div align="center">
            <a href="/application">Start Application</a>
          </div>
        </Card.Body>
         
        <Card.Title className={styles["sectionHeader"]}>
          Application Instructions
        </Card.Title>
        <Card.Body>
          <Card.Text>
            Please carefully review the following steps <em>before</em>{" "}
            submitting a Full Proposal:
          </Card.Text>
          <Card.Text>
            <ul>
              <li>Select one Funding Path</li>
              <li>
                Ensure you meet the eligibility requirements for a RAPID Scholar
              </li>
              <li>
                Confirm that both you and your chosen mentors are current
                members of the{" "}
                <a
                  href="https://www.academicpeds.org/about/join-apa/"
                  target="_blank"
                >
                  Academic Pediatric Association
                </a>{" "}
                or{" "}
                <a
                  href="https://www.academicpeds.org/program/rapid/"
                  target="_blank"
                >
                  other supporting organization, based on selected funding path
                </a>{" "}
                  (If applying for the NIDDK pathway, confirm that both you and your chosen mentor(s) are current members of the Academic Pediatric Association; if applying for the PIDS pathway, confirm that both you and your chosen mentor(s) are current members of PIDS; for the ABP, APS, and Mead Johnson pathways, membership in an academic society is not required)
                </li>
            </ul>
          </Card.Text>

          <Card.Text>
            Please note: Applications cannot be partially completed and saved.
            Make sure you are prepared to complete and submit the entire application
          </Card.Text>
        </Card.Body>
      </Card>
    </Card>
  );
};

export default Home;
